import { Box, BoxProps, Heading, LoadingWheel } from "@vinomofo/components";
import { useEffect, useState } from "react";

import { CurrencyLabel } from "../currency";
import { useCart } from "../../hooks/use-cart";
import { useCredits } from "../../hooks/account/use-credits";
import styled from "styled-components";

const StyledWrapper = styled(Box)<{ inMiniCart: boolean }>`
  @media screen and (max-height: 600px) {
    position: ${({ inMiniCart }) =>
      inMiniCart === true ? "sticky" : "initial"};
    bottom: 80px;
    padding-top: 16px;
    padding-bottom: 16px;
  }
`;

interface ICartTotal extends BoxProps {
  inMiniCart?: boolean;
}

export const CartTotal = (props: ICartTotal): JSX.Element => {
  const { cart, isLoading } = useCart();
  const { credits, isLoading: creditIsLoading } = useCredits();
  const [storeCredit, setStoreCredit] = useState(0);

  useEffect(() => {
    if (credits && credits > 0) {
      setStoreCredit(credits);
    }
  }, [creditIsLoading]);

  return (
    <StyledWrapper
      borderRadius="0 0 5px 5px"
      width="100%"
      px={3}
      py={4}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      backgroundColor="almostWhite"
      fontSize="16px"
      {...props}
    >
      <Heading fontSize="inherit">Total</Heading>
      {isLoading ? (
        <LoadingWheel borderWidth="5px" size="2em" />
      ) : (
        <Heading fontSize="20px" color="primary" data-testid="cart-total-label">
          <CurrencyLabel
            amount={
              storeCredit >= cart?.cartTotal ? 0 : cart?.cartTotal - storeCredit
            }
            // showFree
          />
        </Heading>
      )}
    </StyledWrapper>
  );
};
